import { useState, useEffect } from 'react';
import { StyledIcon } from './input.styles';

const ErrorIcon = ({ shake }: { shake?: number }) => {
	const [shaked, setShaked] = useState(false);

	useEffect(() => {
		if (shake && shake > 0) {
			setShaked(shak => !shak);
		}
	}, [shake]);

	return (
		<StyledIcon
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			fill="none"
			viewBox="0 0 20 20"
			shake={shaked}
			className="u-absolute login-error-icon"
			onAnimationEnd={() => setShaked(false)}
		>
			<path
				fill="#E92636"
				d="M20 10c0 5.524-4.477 10-10 10-5.522 0-10-4.476-10-10C0 4.48 4.478 0 10 0c5.523 0 10 4.48 10 10zm-10 2.016a1.855 1.855 0 100 3.71 1.855 1.855 0 000-3.71zM8.239 5.35l.3 5.484a.484.484 0 00.482.457h1.958c.257 0 .469-.2.483-.457l.299-5.484a.484.484 0 00-.483-.51H8.722a.484.484 0 00-.483.51z"
			/>
		</StyledIcon>
	);
};

export default ErrorIcon;
